import { Tooltip, Text } from "@chakra-ui/react";
import { getTimeFromNow, formatTimestamp } from "utils";

/**
 * Reusable component for displaying timestamps
 * Shows relative time (e.g., "2 hours ago") with a tooltip showing the full formatted date
 *
 * @param {number} timestamp - Unix timestamp
 * @param {object} textProps - Props to pass to the Text component
 * @returns {JSX.Element} Timestamp component with tooltip
 */
const Timestamp = ({ timestamp, ...textProps }) => {
  if (!timestamp) return <Text {...textProps}>-</Text>;

  const relativeTime = getTimeFromNow(timestamp);
  const formattedTime = formatTimestamp(timestamp)
    .split("(")[1]
    .replace(")", "");

  return (
    <Tooltip label={formattedTime} placement="top" hasArrow>
      <Text cursor="pointer" {...textProps}>
        {relativeTime}
      </Text>
    </Tooltip>
  );
};

export default Timestamp;
